import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { IConfiguratorAction } from "@models/entity-models";
import { eRuleType } from "@models/enums";
import { icons } from "@tools";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { RuleContainer } from "@models/configurators/rule-container";

@Kbo(CToken.ConfiguratorAction)
export class ConfiguratorAction extends RuleContainer implements IConfiguratorAction {
    constructor(kom: KbObjectManager) {
        super(kom);

        this.icon = icons.action;
        this.ruleType = eRuleType.action;
    }
    public icon: string;
    public iconStyle: string;
    public textPosition: string;
    public mediaPath: string;
    public visible: boolean;
    public enabled: boolean;
    public imageWidth: number;
    public imageHeight: number;
    public showLabel: boolean;
    public relativeSize: string;
}
